import React from "react";

const PhoneIcon = ({ width, height, color }) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2024 0H2.61849C1.17514 0 0 1.13145 0 2.52099V37.479C0 38.8686 1.17521 40 2.61849 40H19.2024C20.6457 40 21.8209 38.8685 21.8209 37.479V2.52099C21.8209 1.13145 20.6464 0 19.2024 0ZM19.2024 38.9916H2.61849C1.83781 38.9916 1.19259 38.4384 1.07254 37.7177C1.4489 38.4236 2.20445 38.9116 3.08356 38.9116H18.7373C19.6165 38.9116 20.3721 38.4229 20.7483 37.7177C20.6282 38.4384 19.983 38.9916 19.2024 38.9916ZM9.22616 1.86752C9.25128 1.9334 9.31692 1.97642 9.38885 1.97642H12.2406C12.3175 1.97642 12.3851 1.92805 12.4075 1.8574L12.5241 1.48901C12.5311 1.46616 12.5199 1.44599 12.5171 1.42314H18.7367C19.7959 1.42314 20.6569 2.25208 20.6569 3.27189V36.7268C20.6569 37.7466 19.7959 38.5755 18.7367 38.5755H3.08349C2.02424 38.5755 1.16324 37.7466 1.16324 36.7268V3.27259C1.16324 2.25278 2.02424 1.42384 3.08349 1.42384H9.08369C9.08091 1.44936 9.07113 1.47362 9.08157 1.49914L9.22616 1.86752ZM9.42448 1.42384H12.1799L12.1107 1.6403H9.50904L9.42448 1.42384ZM18.7373 1.08772H3.08349C2.20438 1.08772 1.44882 1.57647 1.07247 2.28168C1.19259 1.56163 1.83774 1.00772 2.61842 1.00772H19.2023C19.9829 1.00772 20.6281 1.561 20.7483 2.28168C20.3721 1.57647 19.6165 1.08772 18.7373 1.08772Z"
        fill="#00008B"
      />
      <path
        d="M1.83301 4.28574V33.4454C1.83301 33.5845 1.95028 33.6975 2.09486 33.6975H19.5084C19.6529 33.6975 19.7702 33.5846 19.7702 33.4454V4.28574C19.7702 4.14661 19.653 4.03363 19.5084 4.03363H2.09486C1.95028 4.03363 1.83301 4.14654 1.83301 4.28574ZM2.35672 4.53784H19.2465V33.1934H2.35672V4.53784Z"
        fill="#00008B"
      />
      <path
        d="M11.3906 35.1685H10.3865C9.9047 35.1685 9.51367 35.5456 9.51367 36.0088V36.3032C9.51367 36.7664 9.9047 37.1435 10.3865 37.1435H11.3906C11.8718 37.1435 12.2635 36.7664 12.2635 36.3032V36.0088C12.2635 35.5449 11.8718 35.1685 11.3906 35.1685ZM11.9143 36.3026C11.9143 36.5802 11.679 36.8068 11.3906 36.8068H10.3865C10.0981 36.8068 9.86279 36.5802 9.86279 36.3026V36.0082C9.86279 35.7305 10.0981 35.5039 10.3865 35.5039H11.3906C11.679 35.5039 11.9143 35.7305 11.9143 36.0082V36.3026Z"
        fill="#00008B"
      />
      <path
        d="M15.0852 2.99762C15.3663 2.99762 15.5942 2.7782 15.5942 2.50754C15.5942 2.23687 15.3663 2.01746 15.0852 2.01746C14.8041 2.01746 14.5762 2.23687 14.5762 2.50754C14.5762 2.7782 14.8041 2.99762 15.0852 2.99762Z"
        fill="#00008B"
      />
      <path
        d="M16.5106 35.9207H16.1608V35.7943L15.7837 36.0034L16.1608 36.2132V36.0894H16.5106C16.9449 36.0894 17.1216 36.1083 17.1216 36.2992C17.1216 36.4995 17.0343 36.5089 16.7578 36.5089H16.3067C16.2586 36.5089 16.2195 36.5465 16.2195 36.5929C16.2195 36.6393 16.2586 36.6769 16.3067 36.6769H16.7578C16.998 36.6769 17.2962 36.6769 17.2962 36.2991C17.2962 35.9213 16.896 35.9207 16.5106 35.9207Z"
        fill="#00008B"
      />
      <path
        d="M5.63037 35.6094H4.77916C4.73096 35.6094 4.69189 35.6471 4.69189 35.6934V36.4921C4.69189 36.5385 4.73096 36.5761 4.77916 36.5761H5.63037C5.67856 36.5761 5.71763 36.5385 5.71763 36.4921V35.6934C5.71763 35.6471 5.67856 35.6094 5.63037 35.6094ZM5.54311 36.4074H4.86649V36.0713H5.1723V35.7768H5.54311V36.4074Z"
        fill="#00008B"
      />
      <rect
        x="11.5"
        y="12.5"
        width="29"
        height="15"
        rx="4.5"
        fill="#FAFAFA"
        stroke="#00008B"
      />
      <path
        d="M21.508 21.68L21.736 19.988L20.392 21.044L19.816 20.024L21.388 19.4L19.828 18.8L20.368 17.828L21.748 18.872L21.508 17.156H22.624L22.384 18.872L23.752 17.828L24.28 18.788L22.72 19.412L24.292 20.036L23.728 21.032L22.384 19.988L22.612 21.68H21.508ZM26.7503 26L27.1943 23.9H25.4663V22.52H27.4943L27.8663 20.768H26.1023V19.388H28.1663L28.6103 17.324H30.0503L29.6063 19.388H31.8863L32.3303 17.324H33.7703L33.3383 19.388H34.8983V20.768H33.0383L32.6663 22.52H34.2623V23.9H32.3663L31.9223 26H30.4703L30.9263 23.9H28.6463L28.2023 26H26.7503ZM28.9343 22.52H31.2143L31.5983 20.768H29.3183L28.9343 22.52Z"
        fill="#00008B"
      />
    </svg>
  );
};

export default PhoneIcon;
